export default __webpack_public_path__ + "static/Portfolio - Compressed-63a35814f4ec59c3d1f942a3f29d771c.pdf";